import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post('/api/auth/password-reset/request', { email }); } catch { /* generic response either way */ } finally { setBusy(false); setSent(true); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="forgot-password-form">
        <div>
          <h1 className="text-4xl font-headings font-bold">Reset password</h1>
          <p className="text-sm text-muted-foreground mt-2">Enter your email and we'll send a single-use link valid for 60 minutes.</p>
        </div>
        {sent ? (
          <p className="text-sm rounded-lg border border-border bg-card p-4" data-testid="forgot-password-sent">If an account exists for that email, a reset link has been sent.</p>
        ) : (
          <>
            <div className="space-y-2">
              <Label htmlFor="fp-email">Email</Label>
              <Input id="fp-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-password-email-input" />
            </div>
            <Button type="submit" className="w-full" disabled={busy} data-testid="forgot-password-submit">Send reset link</Button>
          </>
        )}
        <Link to="/login" className="text-sm underline" data-testid="forgot-password-back">Back to sign in</Link>
      </form>
    </div>
  );
}
